<template>
  <svg class="drink-art" viewBox="0 0 64 64" role="img" :aria-label="`Imagen de referencia: ${label}`" xmlns="http://www.w3.org/2000/svg">
    <title>Imagen de referencia: {{ label }}</title>
    <rect width="64" height="64" :fill="bg" />
    <circle cx="52" cy="12" r="18" :fill="accent" opacity=".18" />

    <!-- agua -->
    <g v-if="art === 'agua'">
      <rect x="26" y="8" width="12" height="7" rx="2" fill="#1d4ed8" />
      <path d="M24 17h16l3 9v28a4 4 0 0 1-4 4H25a4 4 0 0 1-4-4V26z" fill="#e0f2fe" stroke="#0369a1" stroke-width="2" stroke-linejoin="round" />
      <path d="M21 34h22v14H21z" fill="#38bdf8" opacity=".55" />
      <path d="M27 40c3-3 7 3 10 0" stroke="#fff" stroke-width="2" fill="none" stroke-linecap="round" />
    </g>

    <!-- gaseosa -->
    <g v-else-if="art === 'gaseosa'">
      <path d="M20 14h24l-3 40a4 4 0 0 1-4 4H27a4 4 0 0 1-4-4z" fill="#fef2f2" stroke="#7f1d1d" stroke-width="2" stroke-linejoin="round" />
      <path d="M22 28h20l-1.4 26a3 3 0 0 1-3 3H26.400a3 3 0 0 1-3-3z" fill="#7f1d1d" />
      <path d="M32 14l6-8" stroke="#c91d20" stroke-width="3" stroke-linecap="round" />
      <circle cx="29" cy="40" r="1.8" fill="#fecaca" /><circle cx="35" cy="46" r="1.4" fill="#fecaca" /><circle cx="33" cy="35" r="1.2" fill="#fecaca" />
    </g>

    <!-- cerveza -->
    <g v-else-if="art === 'cerveza'">
      <rect x="27" y="6" width="10" height="7" rx="2" fill="#92400e" />
      <path d="M28 13h8v9c0 3 5 5 5 12v20a4 4 0 0 1-4 4H27a4 4 0 0 1-4-4V34c0-7 5-9 5-12z" fill="#b45309" stroke="#78350f" stroke-width="2" stroke-linejoin="round" />
      <rect x="25" y="36" width="14" height="12" rx="2" fill="#fde68a" />
      <path d="M28 42h8" stroke="#b45309" stroke-width="2" stroke-linecap="round" />
    </g>

    <!-- jugo -->
    <g v-else-if="art === 'jugo'">
      <path d="M38 6l-5 20" stroke="#c91d20" stroke-width="3" stroke-linecap="round" />
      <path d="M19 20h26l-3 35a4 4 0 0 1-4 4H26a4 4 0 0 1-4-4z" fill="#fff7ed" stroke="#c2410c" stroke-width="2" stroke-linejoin="round" />
      <path d="M20.500 30h23l-2 25a3 3 0 0 1-3 3H25.500a3 3 0 0 1-3-3z" fill="#fb923c" />
      <circle cx="46" cy="22" r="8" fill="#fdba74" stroke="#c2410c" stroke-width="2" /><path d="M46 14v16M38 22h16" stroke="#c2410c" stroke-width="1.500" />
    </g>

    <!-- soda / te hatsu (lata) -->
    <g v-else-if="art === 'lata'">
      <rect x="21" y="12" width="22" height="42" rx="5" fill="#34d399" stroke="#065f46" stroke-width="2" />
      <rect x="23" y="10" width="18" height="4" rx="1.500" fill="#d1d5db" stroke="#6b7280" stroke-width="1.500" />
      <rect x="21" y="26" width="22" height="12" fill="#fff" opacity=".85" />
      <path d="M26 32h12" stroke="#065f46" stroke-width="2.500" stroke-linecap="round" />
      <rect x="23" y="52" width="18" height="4" rx="1.500" fill="#d1d5db" stroke="#6b7280" stroke-width="1.500" />
    </g>

    <!-- cafe / aromatica / tinto -->
    <g v-else-if="art === 'cafe'">
      <path d="M20 26h26v14a12 12 0 0 1-12 12h-2a12 12 0 0 1-12-12z" fill="#fff" stroke="#44403c" stroke-width="2" stroke-linejoin="round" />
      <path d="M22 28h22v6a10 10 0 0 1-10 10 10 10 0 0 1-12-10z" fill="#78350f" />
      <path d="M46 29h4a5 5 0 0 1 0 10h-5" fill="none" stroke="#44403c" stroke-width="2" />
      <path d="M27 20c-2-3 2-4 0-8M35 20c-2-3 2-4 0-8" stroke="#a8a29e" stroke-width="2" fill="none" stroke-linecap="round" />
      <ellipse cx="33" cy="56" rx="16" ry="2.500" fill="#e7e5e4" />
    </g>

    <!-- vino / champaña -->
    <g v-else-if="art === 'vino'">
      <path d="M22 8h20c1 14-2 24-10 25-8-1-11-11-10-25z" fill="#fef2f2" stroke="#7f1d1d" stroke-width="2" stroke-linejoin="round" />
      <path d="M23 18h18c-.500 9-3 14-9 15-6-1-8-6-9-15z" fill="#9f1239" />
      <path d="M32 33v20M23 56h18" stroke="#44403c" stroke-width="3" stroke-linecap="round" />
    </g>

    <!-- licor / whisky / ron -->
    <g v-else-if="art === 'licor'">
      <path d="M16 28h24l-2 24a4 4 0 0 1-4 4H22a4 4 0 0 1-4-4z" fill="#fff7ed" stroke="#78350f" stroke-width="2" stroke-linejoin="round" />
      <path d="M17.500 36h21l-1.500 16a3 3 0 0 1-3 3h-12a3 3 0 0 1-3-3z" fill="#d97706" />
      <rect x="22" y="38" width="9" height="9" rx="1.500" fill="#fef3c7" opacity=".8" />
      <rect x="45" y="10" width="9" height="8" rx="2" fill="#78350f" /><path d="M46 18h7v6c3 3 4 4 4 8v21a3 3 0 0 1-3 3h-9a3 3 0 0 1-3-3V32c0-4 1-5 4-8z" fill="#92400e" stroke="#451a03" stroke-width="2" stroke-linejoin="round" />
    </g>

    <!-- coctel -->
    <g v-else-if="art === 'coctel'">
      <path d="M12 12h40L32 36z" fill="#ecfccb" stroke="#365314" stroke-width="2" stroke-linejoin="round" />
      <path d="M17 16h30L32 32z" fill="#a3e635" />
      <path d="M32 36v18M22 56h20" stroke="#44403c" stroke-width="3" stroke-linecap="round" />
      <circle cx="46" cy="10" r="6" fill="#bef264" stroke="#365314" stroke-width="2" /><path d="M46 4v12M40 10h12" stroke="#365314" stroke-width="1.500" />
    </g>

    <!-- vaso por defecto -->
    <g v-else>
      <path d="M19 14h26l-3 40a4 4 0 0 1-4 4H26a4 4 0 0 1-4-4z" fill="#e0f2fe" stroke="#0369a1" stroke-width="2" stroke-linejoin="round" />
      <path d="M21 30h22l-1.500 24a3 3 0 0 1-3 3H25.500a3 3 0 0 1-3-3z" fill="#38bdf8" opacity=".7" />
      <path d="M36 6l-4 20" stroke="#c91d20" stroke-width="3" stroke-linecap="round" />
    </g>
  </svg>
</template>

<script>
const RULES = [
  [/cocktel|coctel|c[oó]ctel|margarita|mojito|gin|pi[nñ]a colada/, 'coctel', '#ecfccb', '#84cc16'],
  [/vino|champa|copa/, 'vino', '#fff1f2', '#be123c'],
  [/whisk|buchanan|old par|ron |trago|licor|aguardiente/, 'licor', '#fff7ed', '#d97706'],
  [/cerveza|cerv/, 'cerveza', '#fffbeb', '#d97706'],
  [/caf[eé]|capuch|latte|arom[aá]tica|tinto|chocolate/, 'cafe', '#fafaf9', '#78350f'],
  [/jugo|limonada|naranja|mora|lulo|maracuy|fresa/, 'jugo', '#fff7ed', '#fb923c'],
  [/soda|hatsu|t[eé] |te |tonica|t[oó]nica|energ/, 'lata', '#ecfdf5', '#10b981'],
  [/gaseosa|cola|coca|pepsi|sprite|fanta/, 'gaseosa', '#fef2f2', '#c91d20'],
  [/agua/, 'agua', '#eff6ff', '#38bdf8']
]

export default {
  name: 'DrinkArt',
  props: { name: { type: String, default: '' } },
  computed: {
    rule() {
      const n = ' ' + String(this.name).toLowerCase() + ' '
      return RULES.find(([re]) => re.test(n)) || [null, 'vaso', '#f0f9ff', '#38bdf8']
    },
    art() { return this.rule[1] },
    bg() { return this.rule[2] },
    accent() { return this.rule[3] },
    label() { return this.name }
  }
}
</script>

<style>
.drink-art { display: block; width: 100%; height: 100%; }
</style>
